import util from '@bmp-vue/core/api/util'

const controller = 'ParametroProjeto'
export default Object.assign({}, util.GetCrud(controller, null))
